import { render, staticRenderFns } from "./UniversalFieldEditor.vue?vue&type=template&id=19def380&scoped=true&"
import script from "./UniversalFieldEditor.vue?vue&type=script&lang=js&"
export * from "./UniversalFieldEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19def380",
  null
  
)

export default component.exports